export const OrganizationRolesMockData = [
  {
    id: '3a6f4fb1-b42c-ee11-b632-2c6dc19c19d5',
    roleId: '2d01b4d4-8aa6-eb11-94b3-000d3a223666',
    role: 'Mock Organization Role',
    scopeId: '6c40c6c4-7405-4126-a60d-102f29fd2329',
    scopeTitle: 'Mock Organization Role Scope',
    scopeType: 'Mock Organization Role Scope Type',
    hierarchy: '/1/',
    identityId: '6fc728fa-8be4-eb11-b563-000d3a223e1c',
    identityTitle: 'mockuser@gmail.com',
    identityType: 'User',
    expirationDate: '2023-07-27T19:35:16.1964757+00:00',
    rolePermissions: [
      {
        permissionId: '7c23be52-90d5-4952-ae7e-9ec3b20ce552',
        permission: 'SynchronizeSurveys',
        selector: 'Drillhole',
      },
      {
        permissionId: '0037618f-88dd-4859-8fa9-80b20279bca6',
        permission: 'ManageSurveys',
        selector: 'Drillhole',
      },
      {
        permissionId: 'c7c22b79-b583-4bdc-a4fb-031598ebacc2',
        permission: 'ManageDrillholeRoleAssignments',
        selector: 'Drillhole',
      },
      {
        permissionId: 'bf6d986d-32ac-4764-8d5e-5489467e7075',
        permission: 'ViewDrillholeData',
        selector: 'Drillhole',
      },
      {
        permissionId: '7526435d-b51b-4141-91bb-e6a8310bf1e0',
        permission: 'ManageDrillholeInfo',
        selector: 'Drillhole',
      },
      {
        permissionId: 'f77bfb81-e2c2-423d-b324-25d81786c123',
        permission: 'DeleteDrillhole',
        selector: 'Drillhole',
      },
    ],
  },
] as any[];
